import { toast } from "sonner";
import baseApi from "store/api/baseApi";

const jobManagementApi = baseApi.injectEndpoints({
  endpoints: builder => ({
    // Get all jobs
    getAllJobs: builder.query({
      query: () => ({
        url: "qwikITJob/",
        method: "GET",
      }),
      providesTags: ["jobs"],
      transformResponse: response => response.reverse(),
    }),

    // Get a single job by ID
    getJob: builder.query({
      query: id => ({
        url: `qwikITJob/${id}/`,
        method: "GET",
      }),
      providesTags: ["jobs"],
      transformResponse: response => response,
    }),

    // Create a new job
    createJob: builder.mutation({
      query: data => ({
        url: "qwikITJob/new/",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["jobs"],
      transformResponse: response => {
        toast.success("Job created successfully");
        return response;
      },
    }),

    // Update job
    updateJob: builder.mutation({
      query: ({ id, formData }) => ({
        url: `qwikITJob/${id}/`,
        method: "PATCH",
        body: formData,
      }),
      invalidatesTags: ["jobs"],
      transformResponse: response => {
        toast.success("Job updated successfully");
        return response;
      },
    }),

    // Delete job
    deleteJob: builder.mutation({
      query: id => ({
        url: `qwikITJob/${id}/`,
        method: "DELETE",
      }),
      invalidatesTags: ["jobs"],
      transformResponse: response => {
        toast.success("Job deleted successfully");
        return response;
      },
    }),
  }),
});

export const {
  useGetAllJobsQuery,
  useGetJobQuery,
  useCreateJobMutation,
  useUpdateJobMutation,
  useDeleteJobMutation,
} = jobManagementApi;